import React, { useState } from 'react';
import { LayoutContainer } from 'pages/layout/Layout.style';
import Sidebar from 'pages/sidebar';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Footer from './Footer';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import useCapacitorBackButton from 'components/HandleSlideBack';
import DynModel from 'components/Modal';
import AboutUs from 'pages/privacy/AboutUs';
import PrivacyPolicy from 'pages/privacy/PrivacyPolicy';
import TermsAndCondition from 'pages/privacy/TermsAndCondition';
import BeforeLoginHeader from './BeforeLoginHeader';

const paths = ['/settings', '/network', '/business-hub'];
const exactPaths = ['/jobs', '/businessplace', '/jobs/applied-list'];
const sideNavPaths = ['/jobs/applied-list'];

const BeforeLoginLayout = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useCapacitorBackButton();

  const navPath = !(
    paths.find((li) => pathname.startsWith(li)) ||
    exactPaths.find((li) => pathname === li)
  );

  const hideSideNav = !sideNavPaths.find((li) => pathname === li);

  return (
    <>
      <BeforeLoginHeader />
      <LayoutContainer
        className="LayoutContainer"
        isshowaside={navPath ? navPath.toString() : undefined}
      >
        <div className="layout-wrapper">
          <div className={clsx(hideSideNav && 'layout-sub-wrapper')}>
            {hideSideNav && (
              <div className="sidebar fixed-sidebar">
                <Sidebar />
              </div>
            )}
            <main className="content">
              <Outlet />
              {children}
            </main>
            {navPath && (
              <aside>
                <div className="aside-container">
                  <div className="policy-container">
                    <div onClick={() => setIsModalOpen('about')}>
                      {t(`HomePage.AboutUs`)}
                    </div>
                    <div onClick={() => setIsModalOpen('privacy')}>
                      {t(`HomePage.PrivacyPolicy`)}
                    </div>
                    <div onClick={() => setIsModalOpen('terms')}>
                      {t(`HomePage.Terms`)}
                    </div>
                    <div onClick={() => navigate('/blog')}>
                      {t('HomePage.Blog')}
                    </div>
                  </div>
                </div>
              </aside>
            )}
          </div>
          <DynModel
            modalchanges="privacyModal"
            openModal={isModalOpen}
            modelTitle={
              isModalOpen === 'about'
                ? 'About Us'
                : isModalOpen === 'privacy'
                ? 'Privacy Policy'
                : isModalOpen === 'terms' && 'Terms & Condition'
            }
            handleCancelModal={() => setIsModalOpen(false)}
            content={
              isModalOpen === 'about' ? (
                <AboutUs hideBackArrow />
              ) : isModalOpen === 'privacy' ? (
                <PrivacyPolicy hideBackArrow />
              ) : (
                isModalOpen === 'terms' && <TermsAndCondition hideBackArrow />
              )
            }
          />
        </div>
      </LayoutContainer>
      <Footer />
    </>
  );
};
export default BeforeLoginLayout;
